import Axios from 'axios';
import { baseUrlRequestInterceptor } from './axiosAdminUtils';

export const axiosAdminNoAuth = Axios.create();
axiosAdminNoAuth.interceptors.request.use(baseUrlRequestInterceptor);
